const financeEstimator = {
  __typename: 'Finance Estimator',
  paymentType: 'cash', // 'cash' or 'loan'
  msrp: 200000,
  downPayment: 20000,
  financedAmount: 180000,
  term: 60,
  apr: '3.99',
  estimatedPayment: 3314,
  cashDeposit: 5000
};

export default financeEstimator;
